import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "./index.css";
import App from "./App";
import Dashboard from "./Dashboard";
import Widget from "./Widget";
import Embed from "./Embed";
import ProductivityCalculator from "./ProductivityCalculator";
import LandingPage from "./LandingPage";

// Navigation component for easy access to all routes
const Navigation = () => (
  <div className="bg-slate-800 text-white p-4 text-center">
    <div className="max-w-4xl mx-auto">
      <div className="flex flex-wrap justify-center gap-4 text-sm">
        <a href="/" className="hover:text-blue-300 underline">Home</a>
        <a href="/culture" className="hover:text-blue-300 underline">Culture Calculator</a>
        <a href="/productivity" className="hover:text-blue-300 underline">Productivity Calculator</a>
        <a href="/dashboard" className="hover:text-blue-300 underline">Analytics Dashboard</a>
        <a href="/widget" className="hover:text-blue-300 underline">Widget Version</a>
        <a href="/embed" className="hover:text-blue-300 underline">Embed Version</a>
      </div>
    </div>
  </div>
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/culture" element={<App />} />
        <Route path="/productivity" element={<ProductivityCalculator />} />
        <Route path="/dashboard" element={
          <>
            <Navigation />
            <Dashboard />
          </>
        } />
        <Route path="/widget" element={
          <>
            <Navigation />
            <Widget />
          </>
        } />
        <Route path="/embed" element={<Embed />} />
        {/* Catch-all route */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);
